module.exports = __webpack_public_path__ + "static/media/BG_63.2add48fc.png";